import { render, staticRenderFns } from "./Smart_city.vue?vue&type=template&id=54193164"
import script from "./Smart_city.vue?vue&type=script&lang=js"
export * from "./Smart_city.vue?vue&type=script&lang=js"
import style0 from "./Smart_city.vue?vue&type=style&index=0&id=54193164&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports